import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";

export type ExplorerConnectionLimitResponse = {
  isExplorer: boolean;
  used?: number;
  limit?: number;
  remaining?: number;
  weekStartUtc?: string;
  weekResetsUtc?: string;
  canPerformAction?: boolean;
};

interface Props {
  userId: string;
  enabled?: boolean;
}

export function useGetExplorerConnectionLimit({ userId, enabled = true }: Props) {
  return useQuery({
    enabled: enabled && !!userId,
    queryKey: ["explorerConnectionLimit", userId],
    queryFn: async () => {
      const res = await axiosInstance.get<ExplorerConnectionLimitResponse>(
        getAPIURL(`/User/explorerConnectionLimit/${userId}/`)
      );
      return res.data;
    },
    staleTime: 30_000,
  });
}
